<template>
  <div class="block-table-scroller">
    <table class="block-table">
      <caption v-if="table.caption" class="block-table__caption">{{ table.caption }}</caption>
      <thead v-if="table.headers.length">
        <tr>
          <th v-for="(header, index) in table.headers" :key="index" scope="col">{{ header }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in table.rows" :key="rowIndex">
          <td v-for="(cell, cellIndex) in row" :key="cellIndex">{{ cell }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// Renders a normalized table (see tableOf in chat-structured.js). Every cell
// goes through `{{ }}` interpolation, so cell text can never become markup.
export default {
  name: 'ChatTableBlock',
  props: {
    table: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
/* Wide tables scroll sideways inside the bubble instead of widening the chat. */
.block-table-scroller {
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.block-table {
  border-collapse: separate;
  border-spacing: 0;
  min-width: 100%;
  font-size: 14px;
  line-height: 20px;
  color: #202125;
  background-color: #ffffff;
  border: 1px solid rgba(32, 33, 37, 0.12);
  border-radius: 12px;
  overflow: hidden;

  th,
  td {
    padding: 8px 12px;
    text-align: right;
    white-space: nowrap;
    border-bottom: 1px solid rgba(32, 33, 37, 0.08);
  }

  th {
    font-weight: 600;
    background-color: #f6f6f8;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
}

.block-table__caption {
  caption-side: top;
  padding: 0 2px 8px;
  font-size: 15px;
  font-weight: 600;
  text-align: right;
  color: #202125;
}
</style>
